<template>
    <div>
        <div class="text-right">
            <label class="label mb-0 mr-2" for="year"
                ><strong>Year</strong></label
            >
            <select id="year" v-model="year" class="mr-2">
                <option :value="year" v-for="year in years" :key="year">{{
                    year
                }}</option>
            </select>
        </div>
        <div v-if="fieldTargets">
            <div
                class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2"
                v-for="field in fieldTargets.questions"
                :key="field.id"
            >
                <div>
                    <strong>{{ field.title }}</strong>
                </div>
                <div v-if="field.type == 'range'">
                    <label class="readable-text" :for="'score' + field.id"
                        >Score</label
                    >
                    <div>
                        <input
                            :id="'score' + field.id"
                            type="number"
                            class="inline-form"
                            v-model="field.newScore"
                        />
                        / {{ field.isNps ? 10 : surveyOutOf }}
                    </div>
                </div>
                <div v-else>
                    <p class="readable-text"><i>No targets for non-range type questions</i></p>
                </div>
            </div>
            <div class="text-right">
                <button class="btn btn-primary" @click="saveTargets">
                    Create
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import SurveysService from "../../services/surveys-service";
import RecentYearsMixin from "../../mixins/RecentYearsMixin";
export default {
    props: {
        survey: {
            type: Object
        }
    },
    mixins: [RecentYearsMixin],
    watch: {
        year: {
            handler: function (newVal, oldVal) {
                this.assignYearTargets();
            }
        },
        fieldTargets: {
            handler: function (newVal, oldVal) {
                this.assignYearTargets();
            }
        }
    },
    data() {
        return {
            fieldTargets: null
        };
    },
    mounted() {
        this.getSurveyTargets();
    },
    computed: {
        yearTargets() {
            const yearTargets = {}
            const value = this.fieldTargets;

            if (!this.fieldTargets) {
                return {};
            }
            
            for (let field of this.fieldTargets.questions) {
                for (let target of field.targets) {
                    if (!yearTargets[target.year]) {
                        yearTargets[target.year] = {};
                    }
                    yearTargets[target.year][field.id] = target;
                };
            }
            return yearTargets;
        },
        surveyOutOf() {
            if (!this.survey) {
                return 10;
            }            
            return this.survey.options.outOfFive === 1 ? 5 : 10;
        }
    },
    methods: {
        assignYearTargets() {
            if (!this.fieldTargets) {
                return;
            }
            for (let field in this.fieldTargets.questions) {
                const fieldObject = this.fieldTargets.questions[field];
                var newScore = this.yearTargets && this.yearTargets[this.year] && this.yearTargets[this.year][fieldObject.id] ? 
                    this.yearTargets[this.year][fieldObject.id] : 0;
                const outOf = fieldObject.isNps ? 10 : this.surveyOutOf;
                newScore = newScore.score / (100 / outOf);
                this.fieldTargets.questions[field].newScore = newScore;
            }
        },
        async getSurveyTargets() {
            this.fieldTargets = await SurveysService.targets.index(
                this.survey.id
            );
        },
        async saveTargets() {
            const data = await SurveysService.targets.create(
                this.survey.id,
                this.fieldTargets,
                this.year
            );

            if (data.error) {
                swal({
                    title: "Something went wrong",
                    text: data.error,
                    type: "warning",
                    showCloseButton: true,
                    timer: 10000
                });
            } else {
                swal({
                    title: "The targets have been saved successfully.",
                    text: data.message,
                    type: "success",
                    showCloseButton: true,
                    timer: 10000
                });
            }
            this.getSurveyTargets();
        }
    }
};
</script>
